import { generatePath, Navigate } from "react-router-dom";
import { WORK_CONDITIONS_CHANGE_REQUEST_PATH } from "@/modules/requests/pages/work-conditions-change-request";

export function OpenWorkConditionsChangeRequest() {
  const requestId = new URL(window.location.href).searchParams.get("id");

  if (!requestId) {
    return null;
  }

  return (
    <Navigate
      to={generatePath(WORK_CONDITIONS_CHANGE_REQUEST_PATH, {
        requestId,
      })}
    />
  );
}
